module.exports = __webpack_public_path__ + "img/SEAsia.79759c34.png";